const $win = $(window);
const $doc = $(document);

const $header = $('.header');
const headerHeight = $header.outerHeight();
const $btnPopup = $('.btn-popup');
const REQUEST_SUCCESS = '200';
var skipped_step_2 = false;

import 'select2';
import fixedWidget from './sticky.js';
import initializeMap from './googleMap.js';
import { sliderFeaturesInit, sliderCommentsInit, sliderProductInit, mainSliderInit, sliderPartnersInit } from './sliders.js';
import "babel-polyfill";
import 'whatwg-fetch';
import 'jquery-mousewheel';
import 'malihu-custom-scrollbar-plugin';
import 'magnific-popup';

//  Slider
sliderFeaturesInit();
sliderCommentsInit();
sliderProductInit();
mainSliderInit();
sliderPartnersInit();

//  Custom select dropdown
$('select').each(function(){
	var placeholder = $(this).data('placeholder');

	$(this).select2({
		placeholder: placeholder,
		minimumResultsForSearch: Infinity,
		allowClear: false,
		dropdownAutoWidth: true,
		selectOnBlur:false,
	});
});

$(".mCustomScrollbar").mCustomScrollbar({
    axis:"y" // horizontal scrollbar
});

//  Tabs
function tabs() {
	const activeTabClass = 'current';

	$('.tabs__nav a').on('click', function(event) {
		var activeTabClass = 'current';
		var $tabLink = $(this);
		var $targetTab = $($tabLink.attr('href'));

		$tabLink
			.parent()
			.add($targetTab)
			.addClass(activeTabClass)
				.siblings()
				.removeClass(activeTabClass);

		event.preventDefault();
	});
}

tabs();

//  Make header sticky
$win.scroll(function() {
	if ( $(this).scrollTop() > 1 ) {
		$header.addClass('header-fixed');
	} else {
		$header.removeClass('header-fixed');
	}
});

//  Fix sidebar on scroll
fixedWidget();

//Hide the inactive sections
$('.accordion__section').not('.accordion__section--current').find('.accordion__body').hide()

//Handle the show/hide logic
$('.accordion').on('click', '.accordion__head', function (event) {
	$(this).next().stop().slideToggle()
		.parent().toggleClass('accordion__section--current')
		.siblings().removeClass('accordion__section--current')
			.find('.accordion__body').slideUp();

});

//  Expand mobile navigation
$('.nav-trigger').on('click', function(e){
	e.preventDefault();

	$(this).toggleClass('active');

	$('.header .header__inner').toggleClass('expanded');
	$('body').toggleClass('no-scroll');
});

const $sectionAnimation = $('.section-locations');
const $animated = $('.js-animated');
const animatedSrc = $animated.data('src');

$win.on('load', function() {
	if ( $('.map').length ) {
		$('.map').each(function() {
			initializeMap($(this));
		});
	}

	if ( $sectionAnimation.length ) {
		const sectionAnimationTop = $sectionAnimation.offset().top;

		if ($win.scrollTop() + headerHeight*2 > sectionAnimationTop ) {

			if ( !$sectionAnimation.hasClass('animated')) {
				$sectionAnimation.find($animated).attr('src', animatedSrc);
			} else {
				return;
			}

			$sectionAnimation.addClass('animated');
		}
	}

	$btnPopup.trigger('click');
});

$win.on('load resize', function() {
	$('.nav-item-has-children > a').on('click', function(e){
		e.preventDefault();

		if ( $win.width() < 1024 ) {
			$(this).siblings('.dropdown').addClass('dropdown-expanded');
		} else {
			$(this).parent('li').addClass('active').siblings().removeClass('active');
		}
	});

	$('.select2').each(function() {
		const $this = $(this);

		$this.on('click', function(e){
			e.preventDefault()
			const selectWidth = $this.outerWidth();

			$this.parents('body').find('.select2-dropdown').outerWidth(selectWidth);
		});
	});
});

if ( $sectionAnimation.length ) {
	$win.on('scroll', function() {
		const sectionAnimationTop = $sectionAnimation.offset().top;

		if ($win.scrollTop() + headerHeight*2 > sectionAnimationTop ) {

			if ( !$sectionAnimation.hasClass('animated')) {
				$sectionAnimation.find($animated).attr('src', animatedSrc);
			} else {
				return;
			}

			$sectionAnimation.addClass('animated');
		}
	});
}


$('.btn--back').on('click', function(e){
	e.preventDefault();

	$(this).parent().removeClass('dropdown-expanded');
});

function formValidation($form) {
	var $formToValidate = $form;
	var $fieldsRequired = $formToValidate.find('[required], .required input');
	var errorClass = 'form--has-error';

	var regText = /.+/;
	var regEmail = /^[0-9a-zA-Z]+([0-9a-zA-Z]*[-._+])*[0-9a-zA-Z]+@[0-9a-zA-Z]+([-.][0-9a-zA-Z]+)*([0-9a-zA-Z]*[.])[a-zA-Z]{2,6}$/;
	var regNum = /^\d+$/;
	var regTel = /^\d+$/;
	var regUrl = /.+/;

	function validateField($field) {
		var currentVal = $field.val();
		var currentType = $field.attr('type');
		var minLength = $field.attr('minlength');
		var maxLength = $field.attr('maxlength');
		var condition = false;
		var regCurrent = /.+/;

		switch (currentType) {
			case 'email':
				regCurrent = regEmail;
				break;
			case 'tel':
				regCurrent = regTel;
				break;
			case 'url':
				regCurrent = regUrl;
				break;
			case 'number':
				regCurrent = regNum;
				break;
			default:
				regCurrent = regText;
				break;
		}

		condition = regCurrent.test(currentVal);
		condition = $field.attr('minlength') != undefined ? condition && currentVal.length >= minLength : condition;
		condition = $field.attr('maxlength') != undefined ? condition && currentVal.length <= maxLength : condition;

		$field.closest('.form__row').toggleClass('form--has-error', !condition);
	}

	function validateRadiosChecks($radioList) {
		var $radios = $radioList.find('input[type=radio], input[type=checkbox]');

		$radios.each(function () {
			var $this = $(this);

			if ($this.is(':checked')) {
				$radioList.removeClass('form--has-error');
				return false;
			} else {
				$radioList.addClass('form--has-error');
			}
		});
	}

	$formToValidate.on('submit', function (event) {
		var $this = $(this);

		if (!$this.hasClass('form--success')) {
			event.preventDefault();

			$this.addClass('form--validated');

			var $requiredField = $this.find('[required], .required');
			var $radioCheckValidate = $this.find('.required');

			$requiredField.each(function () {
				validateField($(this));
			});

			$radioCheckValidate.each(function () {
				validateRadiosChecks($(this));
			});


			let serialized_form_data = $this.serializeArray();

			const $form_parent = $this.parent();

			if ($form_parent.hasClass('form-steps')) {
				const radio_input_val = $this.find('input[type="radio"]:checked')
					.siblings('label')
						.text()
						.trim();

				serialized_form_data.shift();
				serialized_form_data.unshift({name: 'place', value: radio_input_val});

				if (!skipped_step_2) {
					const step_2_tab_value = $('.tabs__nav li.current > a').html();

					serialized_form_data.push({name: 'size', value: step_2_tab_value});
				} else {
					serialized_form_data.push({name: 'size', value: 'I don\'t know the answer'});
				}

			}

			if (!$this.find('.form--has-error').length) {
				const $ajaxSpinner = $this.find('.form__actions .form-ajax-spinner');

				$.ajax({
					url: $this.attr('action'),
					type: 'POST',
					data: serialized_form_data,
					beforeSend: function() {
						$ajaxSpinner.removeClass('hidden');
					},
					success: function(response) {
						if (response === REQUEST_SUCCESS) {
							$this.addClass('form--success')
								.siblings('.form-error')
									.addClass('hidden')
								.end()
								.siblings('.form-success')
									.removeClass('hidden');
						} else {
							$this.siblings('.form-error').removeClass('hidden');
						}
					},
					error: function(xmr, message,status) {
						$this.siblings('.form-error').removeClass('hidden');
					},
					complete: function() {
						$ajaxSpinner.addClass('hidden');
					}
				});
			}
		}

		event.preventDefault();
	});

	$fieldsRequired.on('input change', function () {
		var $this = $(this);

		if ($this.closest('form').hasClass('form--validated')) {
			validateField($this);

			validateRadiosChecks($this.closest('ul.required'));
		}
	});
}

formValidation($('.validate'));

//  Form Validation

function formSetup($form) {
	formValidation($form);

	if ( $('.form-steps').length ) {
		const $buttons = $('.form-steps').find('.js-step-button');
		const $form = $('.form-steps').find('form');
		const $formNavItem = $('.js-target');
		const $formNavItemMain = $('.form__head').find('.js-target');

		const steps = new Steps({
			steps: '[data-step-index]',
			container: $form[0]
		});

		$buttons.each(function() {
			const button = $(this);

			button.on('click', function(event) {
				event.preventDefault();

				const stepIndex = $(this).closest('.form__group').data('step-index');
				const moveToStep = $(this).attr('data-move-to');

				$(this).closest('.form__group').addClass('completed');
				$(this).addClass('completed');

				$formNavItem.each(function() {
					const $this = $(this);
					const target = $this.data('step');

					if ( moveToStep == target) {
						$this.addClass('completed');
					}
				});

				if ($(this).hasClass('skip-button')) {
					skipped_step_2 = true;
				}

				// If (myFormIsValid) {
				toggleSteps(moveToStep);
				//}
			});
		});

		$formNavItemMain.on('click', function(e){
			e.preventDefault();

			const formNavItemLength = $formNavItemMain.length;
			const $this = $(this);
			const elementToIndex = $(this).data('move-to');
			$('.form__group').eq(elementToIndex).addClass('active').removeClass('completed').prevAll().addClass('completed');

			$this.addClass('active').removeClass('completed').prevAll().addClass('completed');
			$this.addClass('active').removeClass('completed').nextAll().removeClass('active').removeClass('completed');

			$formNavItem.each(function() {
				const $this = $(this);
				const target = $this.data('step');

				if ( elementToIndex == target) {
					$this.addClass('completed').nextAll().removeClass('completed');
					$this.addClass('completed').prevAll().addClass('completed');
				}
			});
		});

		function toggleSteps(moveTo) {
			if ( moveTo == 'next' ) {
				steps.next();
			} else if ( moveTo == 'prev' ) {
				steps.prev();
			} else {
				steps.to(moveTo);
			}
		}
	}

	$('.radio label').click(function(event) {
		const $element = $(this);

		$('.radio').each(function(index, element) {
			const $radio_element = $(element);

			$radio_element.children('input[type="radio"]').attr('checked', false);
		});

		$element.siblings('input[type="radio"]').attr('checked', true);
	});
}

$('.js-load-more').on('click', function(e){
	e.preventDefault();

	$(this).siblings('.products').addClass('expanded');
});

//  Magnific popup
$btnPopup.magnificPopup({
	type: 'ajax',
	alignTop: true,
	overflowY: 'scroll',
	callbacks: {
		ajaxContentAdded: function() {
			$('select').select2({
				minimumResultsForSearch: Infinity,
				allowClear: false,
				dropdownAutoWidth: true,
				autoWidth: false
			});

			formSetup($('.validate'));
			tabs();
			sliderProductInit();
		},
		close: function() {
			setTimeout(function() {
				$btnPopup.trigger('click');
			}, 1000);
		}
	}
});

// Close the select dropdown
$('body').on('click touchstart', function(event){
	const $target = $(event.target);

	if ($target != 'select' && $($target).parents('.select2-container').length == 0 && !$($target).hasClass('select2-container')
    ) {
        $('select').select2('close');
    }

    if ( !$target.hasClass('header') && !$target.parents('.header').length && !$target.hasClass('nav-item-has-children') && !$target.parents('.nav-item-has-children').length) {
        $('.nav-item-has-children.active').removeClass('active');
    };
})




// WEBPACK FOOTER //
// ../src/assets/js/main.js